import {Price} from "../types.ts";

export const PriceDisplayBadge = ({record}: { record: Price }) => {

    const pennies = record.amount || 0;

    const formatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    }).format(pennies as number / 100);

    return formatted;

};
